import React from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import monumentDivisionData from "../../Attraction/monument/monumentDivisionData"; // adjust the path if needed

const DivisionMonument = () => {
  const { divisionName } = useParams(); // get "ratanagirimonument", "nashik", etc.
  const route = useNavigate();
  const selectedLang = useSelector((state) => state.language.selectedLang);

  const t = monumentDivisionData[selectedLang];
  const divisionData = t.divisionsData[divisionName];

  const handleDistrictClick = (path) => {
    if (path) {
      route(`/monuments/${divisionName}/${path}`);
    }
  };

  if (!divisionData) {
    return <p className="p-6 mt-20 text-red-500">Coming soon</p>;
  }

  return (
    <div className="bg-[#F6F6EC] min-h-screen px-4 py-12">
      <div className="text-center mb-8">
        <h1 className="text-[26px] sm:text-4xl md:text-5xl lg:text-[45px] text-black">
          {t.title}
        </h1>
        <p className="font-futura tracking-wider text-sm sm:text-base lg:text-[15px] font-medium mt-2">
          <span style={{ color: "#DD9827" }}>
            <Link to="/" className="hover:underline">{t.breadcrumb.home}</Link> /{" "}
            <Link to="/monuments" className="hover:underline">{t.breadcrumb.page}</Link> /{" "}
          </span>
          {divisionData.label}
        </p>
      </div>

      <div className="px-4 md:px-10 max-w-7xl mx-auto mt-20">
        <div className="flex flex-col md:flex-row gap-8 items-start">
          <div className="bg-[#F6F6EC] rounded-2xl border-[1px] border-[#F8D6BF] p-4 md:w-1/4 w-full mt-4">
            <h2 className="text-left ml-2 text-[14px] sm:text-lg md:text-xl lg:text-[26px] font-semibold pb-2">
              {selectedLang === "English" ? "Districts" : "जिल्हे"}
            </h2>
            <ul className="space-y-1 no-dark-bg">
              {divisionData.districts.map((item) => (
                <li key={item.id}>
                  <button
                    className="
          w-full flex justify-between items-center
          text-gray-800 bg-[#EFEDE0]
          px-3 py-2 rounded-md
          cursor-pointer
          hover:bg-[#FB9C00] hover:text-white
          transition font-futura
        "
                    onClick={() => handleDistrictClick(item.path)}
                  >
                    {/* District Name */}
                    <span className="truncate">{item.name}</span>

                    {/* Count Badge */}
                    <span
                      className="
            ml-3 min-w-[28px] h-[28px]
            flex items-center justify-center
            text-xs font-semibold
            bg-white text-black
            rounded-full
          "
                    >
                      {item.count}
                    </span>
                  </button>
                </li>
              ))}
            </ul>

          </div>

          <div className="flex-1 flex justify-center">
            <img
              src={divisionData.image}
              alt={`${divisionName} Map`}
              className="w-full max-w-2xl h-auto object-contain rounded-md"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DivisionMonument;
